import { t } from '../ui/lang';
// Shared bits for the aggregator ("phone-client") farm UI — the install/setup steps
// used by the post-create config modal (farm-modals.ts) and the "Setup" settings tab
// (aggregator-setup-tab.ts). Kept in one place so both surfaces stay in sync.
/**
 * Google Drive folder holding the mobile farm client APK builds. The operator installs
 * the newest APK from here on each phone. Single source of truth for the link.
 */
export const AGGREGATOR_APK_URL = 'https://drive.google.com/drive/folders/1A0JJeIHZjqy7mMR8ghN7ZX073AwmvSRV?usp=sharing';
/**
 * Install/setup steps for an aggregator farm phone (no modal chrome), shared by the
 * post-create config modal and the Setup settings tab. English-only, matching the
 * panel's tone. The phone runs the mobile farm client and joins this farm over the
 * relay; the client drives the screen through Android's accessibility service, so
 * it streams and runs the clicker on the phone itself — no PC, USB cable or root.
 */
export function aggregatorSetupStepsHtml() {
    return `
        <p class="modal__text">${t('farmdev.agg_step1')}</p>
        <div class="launch-block">
            <a class="tbl-btn" href="${AGGREGATOR_APK_URL}" target="_blank" rel="noopener">⇩ ${t('farmdev.download_apk')} ↗</a>
        </div>
        <p class="modal__text" style="margin-top:10px">${t('farmdev.agg_step2')}</p>
        <p class="modal__text" style="margin-top:6px;font-size:0.85em;opacity:0.7">${t('farmdev.agg_step2_note')}</p>
        <p class="modal__text" style="margin-top:10px">${t('farmdev.agg_step3')}</p>
    `;
}
